import { Box, Button, Group, Input } from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useDebouncedCallback } from "@mantine/hooks";
import { IconCheck, IconTimeDuration15 } from "@tabler/icons-react";
import React, { useState } from "react";
import { formatDateNotTimeZone } from "../../../common/FormatDate/FormatDate";
import { repositoryMdm, repositoryPos } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
type Props = {
  Type: string;
};
export const CardChildrenBill = ({ Type }: Props) => {
  const [search, setSearch] = useState({
    from: "",
    to: "",
    orderNumber: "",
  });

  const handleChangeSearchValue = useDebouncedCallback(
    (value: string, key: string) => {
      setSearch((prevData) => ({ ...prevData, [key]: value }));
    },
    500
  );
  //   console.log("search", search);
  const loadingInDmCt = async () => {
    const from = search.from ? formatDateNotTimeZone(search.from) : null;
    const to = search.to ? formatDateNotTimeZone(search.to) : null;
    const orderNumber = search.orderNumber;
    try {
      if (Type === "bcdh") {
        const response = await repositoryMdm.post<MessageResponse<[]>>(
          `/api/v1/SyncData/sync-thu-chi-don-hang-asia`,
          { from, to }
        );
        if (response?.data) {
          NotificationExtension.Success(
            "Đồng bộ thu, báo cáo đơn hàng từ asia thành công!"
          );
        } else {
          NotificationExtension.Fails(
            "Đồng bộ thu, báo cáo đơn hàng từ asia thất bại!"
          );
        }
      } else if (Type === "dbpb") {
        let url = `/api/v1/CreateSellItem/sync-allcation`;
        const params = new URLSearchParams();

        if (orderNumber) params.append("orderNumber", orderNumber);
        if (from) params.append("From", from);
        if (to) params.append("To", to);

        if (params.toString()) {
          url += `?${params.toString()}`;
        }
        const response = await repositoryPos.get<MessageResponse<[]>>(url);
        if (response?.data) {
          NotificationExtension.Success("Đồng bộ phân bổ thành công!");
        } else {
          NotificationExtension.Fails("Đồng bộ phân bổ thất bại!");
        }
      } else if (Type === "dbgn") {
        const res = await repositoryMdm.post<MessageResponse<any>>(
          "/api/v1/SyncData/sync-gach-no-asia",
          { from, to }
        );

        if (res && res.success) {
          NotificationExtension.Success("Đồng gạch nợ từ asia thành công!");
        } else {
          NotificationExtension.Fails(res?.message);
        }
      } else return;
    } catch (error) {
      console.error(error);
      NotificationExtension.Warn("Đã xảy ra lỗi trong quá trình cập nhật!");
    }
  };

  return (
    <Box mt={10}>
      <Group w="100%" gap={10}>
        <DatePickerInput
          type="default"
          leftSection={<IconTimeDuration15 color="#15aabf" />}
          size="md"
          label="Ngày bắt đầu"
          flex={1}
          placeholder="Từ ngày"
          locale="vi"
          disabled={Type === "dbpb" && search.orderNumber ? true : false}
          valueFormat="DD/MM/YYYY"
          onChange={(e) => {
            handleChangeSearchValue(String(e), "from");
          }}
          clearable
        />
        <DatePickerInput
          leftSection={<IconTimeDuration15 color="#15aabf" />}
          size="md"
          label="Ngày kết thúc"
          placeholder="Đến ngày"
          locale="vi"
          flex={1}
          disabled={Type === "dbpb" && search.orderNumber ? true : false}
          valueFormat="DD/MM/YYYY"
          onChange={(e) => {
            handleChangeSearchValue(String(e), "to");
          }}
          clearable
        />
        {Type === "dbpb" ? (
          <>
            <Input.Wrapper label="Mã đơn hàng">
              <Input
                placeholder="Nhập mã đơn hàng"
                size="md"
                disabled={search.from || search.to ? true : false}
                onChange={(e) => {
                  handleChangeSearchValue(
                    String(e.target.value),
                    "orderNumber"
                  );
                }}
              />
            </Input.Wrapper>
          </>
        ) : (
          ""
        )}
      </Group>
      <Group justify="flex-end">
        <Button
          leftSection={<IconCheck />}
          variant="filled"
          color="blue"
          mt={10}
          onClick={() => loadingInDmCt()}
        >
          Xác nhận
        </Button>
      </Group>
    </Box>
  );
};
